import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, PickaxeIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productEdition, productImage, productImageAlt, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden border-b border-slate-800 bg-slate-950" data-id="element-84" data-mp="sde30u4ypnwa">
      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-85" data-mp="neax77h5rdn9">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-white sm:text-sm" data-id="element-86" data-mp="3d2tqbf4z2uh6">
          <PickaxeIcon className="h-4 w-4 shrink-0 text-orange-400" aria-hidden="true" data-id="element-87" data-mp="3o59efq3thihp" /> {productBrand} · {productEdition}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-88" data-mp="3e8mssz3o2nem">
          <img src={productImage} alt={productImageAlt} className="mx-auto w-full" style={{
          filter: 'drop-shadow(0 0 28px rgba(251, 191, 36, 0.28)) drop-shadow(0 0 70px rgba(234, 88, 12, 0.18))'
        }} data-id="element-89" data-mp="2qk3kwkoj4cn2" />
        </motion.div>

        <div className="mt-9" data-id="element-90" data-mp="2hkghxug5iyrw">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-91" data-mp="2hl9rf36hw2dq">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-300" data-id="element-92" data-mp="s3349bcaykwh">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-93" data-mp="ibowkga76es9">
              <Icon className="h-4 w-4 text-orange-400" aria-hidden="true" data-id="element-94" data-mp="dd5dqoqwhj44" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}